import React from "react";
import Layout from "../../components/Layout.tsx";
import ModalContainer from "../../components/ModalContainer.tsx";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import {
  resetState,
  setColaboradores,
  setLoading,
  setTotal,
  setModalDelete,
  setDataToRemove,
  setFetch,
  setPage,
} from "../../store/slices/colaboradoresSlice.ts";
import { fetchPartners } from "../../services/partner.service.ts";
import { notification } from "../../utils/Notifications.tsx";
import TableColaboradoresSuspendidos from "./TableColaboradoresSuspendidos.tsx";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import { toCamelCase } from "../../hooks/toCameCase.tsx";
import DeletePartner from "../../components/talento-humano/DeletePartner.tsx";
import Title from "../../components/Title.tsx";

const ListControlBajas = () => {
  useAppSettings();
  const dispatch = useDispatch();
  const {
    page,
    limit,
    loading,
    fetch,
    sortBy,
    defaultSort,
    query,
    showDeleteModal,
    dataToRemove,
  } = useSelector((state: RootState) => state.colaboradores);

  const fetchColaboradores = async () => {
    dispatch(setLoading(true));
    try {
      const offset = page === 0 ? 0 : page * limit;
      let filter = `?sort=${sortBy}&order=${defaultSort}&offset=${offset}&limit=${limit}&tab=control-bajas`;

      if (query) {
        filter += `&${query}`;
      }

      const response = await fetchPartners(filter);
      dispatch(setColaboradores(response.results));
      dispatch(setTotal(response.total));
    } catch (error) {
      notification(
        "Error",
        "Error al cargar los colaboradores en control de bajas",
        "danger"
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

  React.useEffect(() => {
    fetchColaboradores();
  }, [page, limit, fetch, sortBy, defaultSort, query]);

  React.useEffect(() => {
    dispatch(resetState());
  }, []);

  return (
    <Layout loading={loading}>
      <div className="m-">
        <Title
          baseTitle="Control de bajas"
          basePath="/colaboradores-suspendidos"
          title="Control de bajas"
        />

        <div className="panel panel-inverse mt-3 m-4">
          <div className="panel-body">
            <TableColaboradoresSuspendidos hideReactivate showApprover />
          </div>
        </div>

        <ModalContainer
          open={showDeleteModal}
          closeFn={() => {
            dispatch(setModalDelete(false));
            dispatch(
              setDataToRemove({
                id: -1,
                name: "",
              })
            );
            dispatch(setFetch(!fetch));
          }}
          title={`Dar de baja a ${toCamelCase(dataToRemove?.name || "")}`}
          children={
            <DeletePartner
              name={dataToRemove?.name}
              programed={dataToRemove?.programed}
              id={dataToRemove?.id}
              closeFn={() => {
                dispatch(setModalDelete(false));
                dispatch(
                  setDataToRemove({
                    id: -1,
                    name: "",
                  })
                );
                dispatch(setFetch(!fetch));
                dispatch(setPage(0));
              }}
            />
          }
        />
      </div>
    </Layout>
  );
};

export default ListControlBajas;
